import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface CookieStore {
  cookieAccepted: boolean;
  toggleCookieAccepted: (newCookieAccepted: boolean) => void;
}

export const useCookieStore = create<CookieStore>()(
  persist(
    (set) => ({
      cookieAccepted: false,
      toggleCookieAccepted: (newCookieAccepted: boolean) =>
        set({ cookieAccepted: newCookieAccepted }),
    }),
    {
      name: "cookie-accepted",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
